import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

export default function RecentDeliveryAccordion(props) {
	const { userData, status } = props;

	console.log(userData);
	return (
		<div>
			{typeof userData === "undefined"
				? "Loading..."
				: userData.length === 0
				? "No deliveries to show."
				: userData
						.filter((d) => d.shipmentStatus === status)
						.map((data) => (
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="panel1-content"
									id="panel1-header">
									{/* <Typography component="span">
									<LocalShippingIcon className="inline-block  text-red-500" />{" "}
									S/R:
									{data?.senderFullName}/{data?.recipientFullName}
								</Typography> */}

									<ul className="  min-w-full  text-[0.8rem]   bg-blue-50  ">
										<li className="py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												Tracking Code:
											</span>
											{data?.trackingNumber}{" "}
										</li>

										<li className="border-y  border-y-gray-200  py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												Sender:
											</span>
											{data?.senderFullName}{" "}
										</li>
										<li className="py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												Reciver:
											</span>
											{data?.recipientFullName}{" "}
										</li>
									</ul>
								</AccordionSummary>
								<AccordionDetails>
									{/* <Typography>
										Lorem ipsum dolor sit amet, consectetur adipiscing elit.
										Suspendisse malesuada lacus ex, sit amet blandit leo
										lobortis eget.
									</Typography> */}
									<ul className="text-[0.8rem]  ">
										{/* <li className="py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												Tracking Code:
											</span>
											{data?.trackingNumber}{" "}
										</li> */}
										<li className="py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												Locaion:
											</span>
											{data?.currentLocation}{" "}
										</li>

										<li className="border-y  border-y-gray-300  py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												Shipment Status:
											</span>
											{data?.shipmentStatus}{" "}
										</li>
										<li className="py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												E.D.D:
											</span>
											{data?.estimatedDeliveryDate}{" "}
										</li>
										<li className=" border-y  border-y-gray-300   py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												A.D.D:
											</span>
											{data?.actualDeliveryDate}{" "}
										</li>
										<li className="    py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												From Country:
											</span>
											{data?.fromCountry}{" "}
										</li>
										<li className=" border-y  border-y-gray-300   py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												From City:
											</span>
											{data?.fromCity}{" "}
										</li>
										<li className="   py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												To Country:
											</span>
											{data?.toCountry}{" "}
										</li>
										<li className=" border-y  border-y-gray-300   py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												To City:
											</span>
											{data?.toCity}{" "}
										</li>
										<li className="  py-[0.2rem]">
											<span className="font-medium inline-block  mr-[0.2rem]">
												{" "}
												Shipment Mode:
											</span>
											{data?.isBuusiness ? "Business" : "personal"}{" "}
										</li>
									</ul>
								</AccordionDetails>
							</Accordion>
						))}
			{/* <Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2-content"
					id="panel2-header">
					<Typography component="span">
						<LocalShippingIcon className="inline-block  text-red-500" /> S/R:
						john/lan
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
						malesuada lacus ex, sit amet blandit leo lobortis eget.
					</Typography>
				</AccordionDetails>
			</Accordion> */}
			<Accordion disabled>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel3-content"
					id="panel3-header">
					<Typography component="span">
						<LocalShippingIcon className="inline-block  text-red-500" /> S/R:
						--/--
					</Typography>
				</AccordionSummary>
			</Accordion>
		</div>
	);
}
